import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Company } from "../domain/company";
import { MessageService } from "primeng/api";
import { Configuration } from "../domain/configuration";
import { DynamicBackendConfigService } from "./dynamic-backend-config.service";
import { Observable, catchError, switchMap, tap } from "rxjs";
import { AppConfigService } from "./app-config.service";
import { Utils } from "src/app/utilities/utils";

@Injectable()
export class CompanyService {

    uriPath = '/api/company'
    uri = "";
    apiUrl="";

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private dynamicBackend : DynamicBackendConfigService,
        private appConfigService: AppConfigService
    ) {
        console.log("this.appConfigService.apiUrl")
        console.log(this.appConfigService.apiUrl)
        this.apiUrl = this.appConfigService.apiUrl;
       /*this.dynamicBackend.getApiUrl().subscribe(apiUrl => { 
            //this.uri = apiUrl ? `${apiUrl}/api/company` : ''; 
            this.uri = this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
        });*/

    }

    getAll(): Promise<Company[]> {
        let promise = this.http
            .get<Company[]>(`${this.apiUrl}${this.uriPath}/companies/all`)
            .toPromise();

        return promise;
    }

    /* getAll(): Observable<Company[]> {
        return this.dynamicBackend.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}/api/company`; // Use the obtained apiUrl
                return this.http.get<Company[]>(`${url}/companies/all`);
            })
        );
    } */

    get(): Promise<Company[]> {
        let promise = this.http
            .get<Company[]>(`${this.apiUrl}${this.uriPath}/companies`)
            .toPromise();
        return promise;
    }

    /* get(): Observable<Company[]> {
        return this.dynamicBackend.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl+"/api/company"}/companies`; // Use the obtained apiUrl
                return this.http.get<Company[]>(url);
            })
        );
    } */

    getById(id): Promise<Company> {
        let promise = this.http.get<Company>(`${this.apiUrl}${this.uriPath}/${id}`).toPromise();
        return promise;
    }

    /* getById(id): Observable<Company> {
        return this.dynamicBackend.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}/api/company/${id}`; // Use the obtained apiUrl
                return this.http.get<Company>(url);
            })
        );
    } */

    post(obj: Company) {
        let promise = this.http.post<Company>(`${this.apiUrl}${this.uriPath}`, obj).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Company created!",
                });
                obj.id = oa.id;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to update company. Check console for errors.",
                    detail:  Utils.extractSQLError(error.error),
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

    /* post(obj: Company): Observable<Company> {
        return this.dynamicBackend.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}/api/company`; // Use the obtained apiUrl
                return this.http.post<Company>(url, obj).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Company created!"
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Failed to update company. Check console for errors.",
                            detail: error.status
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    } */

    put(obj: Company, id: string) {
        if (id == "new")
        {
            return this.post(obj);
        }
        let promise = this.http
            .put<Company>(`${this.apiUrl}${this.uriPath}/${id}`, obj)
            .toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Company updated!",
                });
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to update company. Check console for errors.",
                    detail: Utils.extractSQLError(error.error),
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

    /* put(obj: Company, id: string): Observable<Company> {
        if (id === "new") {
            return this.post(obj);
        }
    
        return this.dynamicBackend.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}/api/company/${id}`; // Use the obtained apiUrl
                return this.http.put<Company>(url, obj).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Company updated!"
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Failed to update company. Check console for errors.",
                            detail: error.status
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    } */

    delete(id: string) {
        let promise = this.http.delete(`${this.apiUrl}${this.uriPath}/${id}`).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "Company deleted.",
                });
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to delete company. Check console for errors.",
                    detail: Utils.extractSQLError(error.error),
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

    /* delete(id: string): Observable<void> {
        return this.dynamicBackend.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}/api/company/${id}`; // Use the obtained apiUrl
                return this.http.delete<void>(url).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Company deleted."
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Failed to delete company. Check console for errors.",
                            detail: error.status
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    } */
    
}
